//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const Sort = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="Sort"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.25797 5.38492L7.02305 2.43184H7.02297C7.28275 2.15551 7.63472 2 8.00137 2C8.36837 2 8.72002 2.15551 8.97977 2.43184L11.7236 5.35861C12.0446 5.69094 12.0918 6.22292 11.8348 6.61371C11.6814 6.83597 11.4447 6.97613 11.1869 6.99716C10.929 7.01852 10.6752 6.91873 10.4917 6.72384L8.0014 4.06507L5.53608 6.69812C5.2248 7.04086 4.72621 7.09125 4.36019 6.81693C4.15263 6.65308 4.02229 6.40078 4.00259 6.12579C3.9829 5.85113 4.07605 5.58082 4.25797 5.38492ZM4.25797 10.6151L7.02305 13.5682H7.02297C7.28275 13.8445 7.63472 14 8.00137 14C8.36837 14 8.72002 13.8445 8.97977 13.5682L11.7236 10.6414C12.0446 10.3091 12.0918 9.77708 11.8348 9.38629C11.6814 9.16403 11.4447 9.02387 11.1869 9.00284C10.929 8.98148 10.6752 9.08127 10.4917 9.27616L8.0014 11.9349L5.53608 9.30188C5.2248 8.95914 4.72621 8.90875 4.36019 9.18307C4.15263 9.34692 4.02229 9.59922 4.00259 9.87421C3.9829 10.1489 4.07605 10.4192 4.25797 10.6151Z"
            fill="currentColor"
          />
        </svg>
      }
      {...restProps}
    />
  );
};
